import { ANALYTICS_MEASURE_TYPE } from "../../scheme/components/analytics/interfaces";
import { MULTI_ANALYSIS_MEASURE_TYPE } from "../types";

export const mapMultiAnalysisMeasureTypeToAnalytics = (
  measureType: MULTI_ANALYSIS_MEASURE_TYPE,
): ANALYTICS_MEASURE_TYPE => {
  switch (measureType) {
    case MULTI_ANALYSIS_MEASURE_TYPE.SIGNAL_FORM:
      return ANALYTICS_MEASURE_TYPE.SIGNAL_FORM;
    case MULTI_ANALYSIS_MEASURE_TYPE.ORBIT:
      return ANALYTICS_MEASURE_TYPE.ORBIT;
    case MULTI_ANALYSIS_MEASURE_TYPE.POLAR_TREND:
      return ANALYTICS_MEASURE_TYPE.TREND;
    case MULTI_ANALYSIS_MEASURE_TYPE.SPECTRUM:
    default:
      return ANALYTICS_MEASURE_TYPE.SPECTRUM;
  }
};

export const mapMultiAnalysisMeasureTypeToTrendDataAnalytics = (
  measureType: MULTI_ANALYSIS_MEASURE_TYPE,
): ANALYTICS_MEASURE_TYPE => {
  switch (measureType) {
    case MULTI_ANALYSIS_MEASURE_TYPE.SPECTRUM:
      return ANALYTICS_MEASURE_TYPE.SPECTRUM;
    case MULTI_ANALYSIS_MEASURE_TYPE.SIGNAL_FORM:
      return ANALYTICS_MEASURE_TYPE.SIGNAL_FORM;
    default:
      return ANALYTICS_MEASURE_TYPE.TREND;
  }
};
